import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { SarlaftTypificationProps } from './props';
import { SarlaftTypification } from '../../../../../../shared/types/modules/sarlaft';
import { asyncGetParams } from '../../../../../../services/param.service';
import { ISelect, ParamEnum } from '../../../../../../shared/types/shared';

export const useSarlaftTypification = ({
    data,
    onChangeData,
    onChangeFormik,
}: SarlaftTypificationProps) => {
    const [typifications, setTypifications] = useState<ISelect[]>([]);
    const [typifications2, setTypifications2] = useState<ISelect[]>([]);
    const onSubmit = (data: SarlaftTypification) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('typification1', data?.typification1 || '');
        formik?.setFieldValue('typification2', data?.typification2 || '');
    }, [data]);

    useEffect(() => {
        if (Boolean(formik.values.typification1)) {
            asyncGetParams(
                ParamEnum.SARLAFT_TYPIFICATION2,
                undefined,
                formik.values.typification1
            ).then((items) => setTypifications2(items));
        }
        if (!data || !Boolean(data.typification2)) {
            formik?.setFieldValue('typification2', '');
        }
    }, [formik.values.typification1]);

    useEffect(() => {
        asyncGetParams(ParamEnum.SARLAFT_TYPIFICATION).then((items) =>
            setTypifications(items)
        );
    }, []);

    return {
        formik,
        typifications,
        typifications2,
    };
};
